import React from "react";

export interface SwitchProps {
    activeLabel?: string;
    inactiveLabel?: string;
    label?: string;
    name: string;
    onChange: (e: unknown) => void;
    value?: boolean | string;
    disabled?: boolean;
    legend?: string;
    setValue?: (value: string) => void;
    setError?: (error: string) => void;
    error?: string;
}

export const Switch: React.FC<SwitchProps> = ({
	                       activeLabel = `Yes`,
	                       inactiveLabel = `No`,
	                       label,
	                       name,
	                       onChange,
	                       value,
                       }: SwitchProps) => {

	return (
		<label className="switch large" htmlFor={name}>
			<div className={`show-for-sr`}>{label}</div>
			<input className="switch-input" id={name} data-testid={name} type="checkbox" name={name} checked={value === true || value === 'true'}
			       onChange={onChange}/>
			<div className="switch-paddle" aria-hidden="true">
				<span className="switch-active">{activeLabel}</span>
				<span className="switch-inactive">{inactiveLabel}</span>
			</div>
		</label>
	);
};
